import { CommonModule } from '@angular/common';
import { HttpClient, HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AppSettingsService } from './config/app-settings.service';
import { ConfigService } from './config/config.service';
import { ErrorHandlerService } from './error-handler/error-handler.service';
import { HttpInterceptorService } from './http-interceptor/http-interceptor.service';
import { LogPublishersService } from './logger/log-publishers.service';
import { LoggerService } from './logger/logger.service';
import { SpinnerService } from './spinner/spinner.service';
import { LanguageService } from './cache/language.service';
import { OidcAuthService } from './oidc-auth/oidc-auth.service';
import { CorrelationIdService } from './services/correlation-id.service';
import { UtilityService } from './services/utility.service';
import { APP_INITIALIZER, NgModule, inject } from '@angular/core';


export function load_config(configService: ConfigService, authService: OidcAuthService) {
  return () => configService.getSettings().then(() => authService.loadConfiguration());
}

// AoT requires an exported function for factories
export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient, './assets/i18n/', '.json');
}

@NgModule({
  imports: [
    CommonModule,
    TranslateModule.forRoot({ loader: { provide: TranslateLoader, useFactory: HttpLoaderFactory, deps: [HttpClient] } })
  ],
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    SpinnerService, ConfigService, AppSettingsService, LoggerService, LogPublishersService, ErrorHandlerService, LanguageService,
    { provide: HTTP_INTERCEPTORS, useClass: HttpInterceptorService, multi: true },
    { provide: APP_INITIALIZER, useFactory: load_config, deps: [ConfigService, OidcAuthService], multi: true },
    CorrelationIdService,
    UtilityService
  ]
})
/** Core Module */
export class CoreModule {
  constructor() {
    const parentModule = inject(CoreModule, { optional: true, skipSelf: true });

    if (parentModule) {
      throw new Error(
        'CoreModule is already loaded. Import it in the AppModule only');
    }
  }
}
